module.exports = __webpack_public_path__ + "app/announcement/announcement-list-2MXQTmsO.html";